<template>
  <DeckControlsContainer class="contact-us-btn" :style="{ transition: `all ${transitionDuration}s` }">
    <DeckControlButton class="p-3.5" :is-active="isDropdownShowing" data-testid="contact-us-btn" @click="onButtonClicked">
      Contact Us
      <div
        v-show="isDropdownShowing"
        class="contact-us-dropdown absolute z-10 w-max rounded-md shadow-md mt-7 ml-96 bg-white bg-opacity-50 backdrop-blur-xl"
        data-testid="book-a-meeting-dropdown"
      >
        <ul class="mb-0 text-gray-800 text-sm font-normal">
          <li class="px-4 py-3 border-b border-black border-opacity-20">
            <button class="option" data-testid="contact-us-aaq-btn" @click="$emit('on-aaq-clicked')">
              <span class="mr-8">Ask a Question</span>
              <ChatBubbleLeftRightIcon class="w-6 h-6" />
            </button>
          </li>
          <li class="px-4 py-3 border-b border-black border-opacity-20">
            <a
              v-analytics="'bookAMeetingClicked'"
              class="option"
              :href="`/meetings/book/${deck.request_setting_id}`"
              target="_blank"
              data-testid="contact-us-book-meeting-btn"
            >
              <span class="mr-8">Book a Meeting</span>
              <CalendarIcon class="w-6 h-6" />
            </a>
          </li>
          <li v-if="deck.company.phone_number" class="px-4 py-3">
            <a class="option" :href="`tel:${deck.company.phone_number}`" data-testid="contact-us-call-btn">
              <span class="mr-8">Call Us</span>
              <PhoneIcon class="w-6 h-6" />
            </a>
          </li>
        </ul>
      </div>
    </DeckControlButton>
  </DeckControlsContainer>
</template>

<script lang="ts" setup>
import { ChatBubbleLeftRightIcon, CalendarIcon, PhoneIcon } from '@heroicons/vue/24/solid'
import type { Deck, IncludeCompany } from '@/entities/deck'
import type { DeepReadonly } from 'vue'

defineProps({
  transitionDuration: {
    type: Number,
    default: 0.5,
  },
  deck: {
    type: Object as PropType<DeepReadonly<Deck & IncludeCompany>>,
    required: true,
  },
})

defineEmits(['on-aaq-clicked'])

const { $analytics } = useNuxtApp()
const isDropdownShowing: Ref<boolean> = ref(false)
const onButtonClicked = () => {
  isDropdownShowing.value = !isDropdownShowing.value
}

watch(
  () => isDropdownShowing.value,
  newValue => {
    if (newValue) {
      $analytics.track('showedButtonBookAMeeting', { location: 'deck-content' })
    }
  }
)
</script>

<style lang="stylus" scoped>
.contact-us-dropdown
  backdrop-filter: blur(54px)

.option
  @apply appearance-none p-0 flex justify-between items-center w-full bg-transparent whitespace-nowrap text-base text-gray-900
</style>
